import { h } from "preact";
import { classNames } from "../../helpers";

export default function StepCircle({ lavender, number }) {
  return (
    <span
      class={classNames("step-circle", lavender && "step-circle--lavender")}
    >
      {number}.
    </span>
  );
}
